import { useState } from 'react';
import { Box, styled } from '@mui/material';
import Dialog, { DialogPrimaryButton } from './Dialog';
import InputField from './InputField';
import api from '../services/api';
import { showGlobalToast } from '../services/toastBus';

const InputWrapper = styled(Box)({
  marginBottom: 16,
  '&:last-of-type': {
    marginBottom: 30,
  },
});

const ChangePasswordDialog = ({ open, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    onClose();
  };

  const handleSubmit = async () => {
    if (newPassword !== confirmPassword) {
      return;
    }

    setIsSubmitting(true);
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    setIsSubmitting(false);

    if (!response?.ok) {
      return;
    }

    showGlobalToast('Mot de passe modifié avec succès', 'success');
    handleClose();
  };

  const canSubmit =
    currentPassword.trim() &&
    newPassword.trim() &&
    confirmPassword.trim() &&
    newPassword === confirmPassword;

  return (
    <Dialog open={open} onClose={handleClose} title="CHANGER LE MOT DE PASSE">
      <InputWrapper>
        <InputField
          label="Mot de passe actuel"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          type="password"
          fullWidth
          withPasswordToggle
          onClear={currentPassword ? () => setCurrentPassword('') : undefined}
        />
      </InputWrapper>
      <InputWrapper>
        <InputField
          label="Nouveau mot de passe"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          type="password"
          fullWidth
          withPasswordToggle
          onClear={newPassword ? () => setNewPassword('') : undefined}
        />
      </InputWrapper>
      <InputWrapper>
        <InputField
          label="Confirmer le nouveau mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          type="password"
          fullWidth
          withPasswordToggle
          onClear={confirmPassword ? () => setConfirmPassword('') : undefined}
        />
      </InputWrapper>
      <DialogPrimaryButton
        variant="contained"
        onClick={handleSubmit}
        disabled={!canSubmit || isSubmitting}
      >
        ENREGISTRER
      </DialogPrimaryButton>
    </Dialog>
  );
};

export default ChangePasswordDialog;
